"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8824],{

/***/ 98824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Filters_CitySearch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./Layout/PreConListing/Filters/Options.ts
var options = [
    {
        id: "1",
        label: "Niagara Falls",
        slug: "Niagara-Falls"
    },
    {
        id: "2",
        label: "Ottawa",
        slug: "Ottawa"
    },
    {
        id: "3",
        label: "Haldimand",
        slug: "Haldimand"
    },
    {
        id: "4",
        label: "Markham",
        slug: "Markham"
    },
    {
        id: "5",
        label: "Durham",
        slug: "Durham"
    },
    {
        id: "6",
        label: "Waterloo",
        slug: "Waterloo"
    }, 
];
/* harmony default export */ var Options = (options);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
;// CONCATENATED MODULE: ./Layout/PreConListing/Filters/CitySearch.tsx








var CityBar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(7168)]).then(__webpack_require__.bind(__webpack_require__, 64050));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64050)
            ];
        }
    },
    suspense: true
});
var CitySearch = function() {
    var ref = (0,react.useState)(Options), options = ref[0], setOptions = ref[1];
    var router = (0,next_router.useRouter)();
    var _onSearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(196), __webpack_require__.e(1422)]).then(__webpack_require__.bind(__webpack_require__, 11422))
                        ];
                    case 1:
                        return [
                            4,
                            _state.sent().default(value)
                        ];
                    case 2:
                        res = _state.sent();
                        if (res.ok) {
                            setOptions(res.data.data);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function _onSearch(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSearch = (0,useDebounce/* default */.Z)(_onSearch, 200);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full p-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CityBar, {
            onSearch: onSearch,
            mode: "screen",
            options: options,
            onSelect: function(city) {
                return router.push("/newconstruction/city/".concat(city));
            }
        })
    });
};
/* harmony default export */ var Filters_CitySearch = (CitySearch);


/***/ })

}]);